/* eslint no-console: 0 */

/**
 * Utility function that lets us express reducers as
 * object mapping from action types to handlers.
 *
 * @param  {Any} initialState
 * @param  {Object} handlers
 * @return {Function}
 */
export const INIT = 'INIT'

export default function createReducer (initialState, handlers) {

  return function reducer (state = initialState, action) {

    if (handlers.hasOwnProperty((action.type))) {

      if (process.env.NODE_ENV === 'development') {
        if (action.type === INIT) {
          console.warn(`Overriding "INIT" handler for "${handlers.name}" reducer. Could cause unexpected behavior.`)
        }
      }

      return handlers[action.type](state, action)
    } else if (action.type === INIT) {
      // merge dehydrated state from server into initialState
      // {} -> initialState -> serverState
      return { ...initialState, ...state }
    }

    return state
  }

}
